import React from 'react';
import { Navigate } from 'react-router-dom';
import { connect } from 'react-redux';
import withRouter from '../../services/util/withRouter';
import API from '../../services/api/api';
import EditorAPI from '../../services/api/apiEditor';

const PluginPrivateRoute = ({ children, location }) => {
	const searchParams = new URLSearchParams(location.search);
	const pluginToken = searchParams.get('pluginToken');
	const hardwareID = searchParams.get('hardwareID');

	API.setToken(pluginToken);
	EditorAPI.setToken(pluginToken);

	return !!pluginToken && !!hardwareID ? (
		children
	) : (
		<Navigate to="/login" replace />
	);
};

export default withRouter(PluginPrivateRoute);
